import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {LexicalNode} from 'lexical';
import {BeautifulMentionsItem} from 'lexical-beautiful-mentions';

import {useRef} from 'react';

import {useDeepCompareEffect, useLatest, useOnMount} from 'shared/web';

import {TextEditorReadyHandler} from '../../../types/TextEditorApi';
import {createSuggestionInputEditorApi} from '../utils/createSuggestionInputEditorApi';

interface EditorBridgePluginProps {
  onEditorReady: TextEditorReadyHandler | undefined;
  transformStringToNodes: (value: string | null) => LexicalNode[];
  options: BeautifulMentionsItem[];
  isLoadingOptions: boolean | undefined;
}

export const EditorBridgePlugin = (props: EditorBridgePluginProps) => {
  const [editor] = useLexicalComposerContext();
  const onEditorReadyRef = useLatest(props.onEditorReady);
  const transformStringToNodesRef = useLatest(props.transformStringToNodes);
  const bridgeRef = useRef<ReturnType<typeof createSuggestionInputEditorApi> | null>(null);

  useDeepCompareEffect(() => {
    bridgeRef.current?.invalidateSelection();
  }, [props.options, props.isLoadingOptions]);

  useOnMount(
    () => {
      const bridge = createSuggestionInputEditorApi(editor, (value) =>
        transformStringToNodesRef.current(value)
      );
      bridgeRef.current = bridge;
      onEditorReadyRef.current?.(bridge.api);
    },
    () => {
      bridgeRef.current?.dispose();
      bridgeRef.current = null;
      onEditorReadyRef.current?.(null);
    }
  );

  return null;
};
